<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog" :class="dialogSizeClass">
        <div class="modal-content">
          <div v-if="isVisible" class="modal-header">
            <h5 class="modal-title">{{ safeConfig.title || 'No Title Found' }}</h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="handleCancel"
            ></button>
          </div>

          <div class="modal-body">
            <!-- <div style="color: red">
              safeConfig: {{ safeConfig }}
            </div> -->
            <component
              :is="componentToRender"
              v-if="isVisible && componentToRender"
              v-bind="componentProps"
              v-on="componentEvents"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div v-else-if="safeConfig.value?.html" v-html="safeConfig.value.html"></div>
            <div v-else>{{ safeConfig.value?.message || '' }}</div>
          </div>

          <div
            v-if="safeConfig && !safeConfig.hideFooter"
            class="modal-footer"
          >
            <button
              v-if="!safeConfig.okOnly && safeConfig.cancelTitle"
              type="button"
              class="btn btn-secondary"
              :disabled="safeConfig.cancelDisabled || false"
              @click="handleCancel"
            >
              {{ safeConfig.cancelTitle || t('button.cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="okDisabled"
              @click="handleOk"
            >
              {{ safeConfig.okTitle || t('button.ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

const store = useStore()
const { t } = useI18n()

const isVisible = computed(() => store.state.modal.isVisible)
const config = computed(() => store.state.modal.config)
const safeConfig = computed(() => {
  return config.value || {}
})

const componentToRender = computed(() => safeConfig.value?.component || null)
const componentProps = computed(() => safeConfig.value?.props || {})
const componentEvents = computed(() => safeConfig.value?.events || {})

const okDisabled = computed(() => {
  return config.value?.okDisabled ?? false
})
const handleOk = () => store.dispatch('modal/confirm')
const handleCancel = () => store.dispatch('modal/cancel')

const dialogSizeClass = computed(() => {
  switch (config.value.size) {
    case 'sm': return 'modal-sm'
    case 'lg': return 'modal-lg'
    case 'xl': return 'modal-xl'
    default: return 'modal-md'
  }
})
</script>
